export default __webpack_public_path__ + "static/media/athleteHomepageNew.f7ec8b5b.png";